import './app.css'
import icons from './icons'

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Object.keys(icons).forEach(icon => Vue.component(icon, icons[icon]))
  },
}
